import { render, staticRenderFns } from "./DraftPurchaseRequest.vue?vue&type=template&id=8e2866e0"
import script from "./DraftPurchaseRequest.vue?vue&type=script&lang=js"
export * from "./DraftPurchaseRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports